import { sendRequest } from "../helper";

type getIgTokenDebugResponse = {
	status: string;
	message: string;
	data: any;
};

export const getIgTokenDebug = ({ token }: { token: string }) => {
	const queryKey = ["instagram", token];
	const queryFunction = () =>
		sendRequest<getIgTokenDebugResponse>(
			"get",
			`/log/debug-social-media-token?platform=instagram&token=${token}`,
			false,
		).then((res) => {
			return res.data;
		});
	return [queryKey, queryFunction] as const;
};
